const isAndroid = () => {
  return /Android/.test(navigator.userAgent) && navigator.maxTouchPoints > 1 && !window.MSStream;
};

export default isAndroid;
